import { render, staticRenderFns } from "./food-diary-form.vue?vue&type=template&id=8a404ffe&"
import script from "./food-diary-form.vue?vue&type=script&lang=js&"
export * from "./food-diary-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports